import {
  Component, ComponentRef, ElementRef,
  Injector,
  Input,
  OnDestroy,
  OnInit, Renderer2,
  ViewChild,
  ViewContainerRef, AfterViewInit, ViewEncapsulation
} from '@angular/core';


import {CommonModule} from "@angular/common";
import {SearchResultModule} from "./components/search-result.module";
import {DynamicComponentService} from "../../../../core/services/dynamic-component/dynamic-component.service";
import {UtilService} from "../../../../core/services/util/util.service";
import {FullTextSearchConfigurationModel} from "../../../../core/models/full-text-search/full-text-search-configuration.model";
import {SharedModule} from "../../../../shared/shared.module";

/**
 * Typical full component (this is for CatalogItem):

  @Component({
  selector: '',
  template: `<sb-search-welcome [firstName]="Name"></sb-search-welcome>

  <div class="dynamic-demo">
  <label>Name</label><span>{{Name}}</span>
  <label>Active</label><span>{{Active}}</span>
  <label>Name field</label><span>{{NameField}}</span>
  <label>Name field2</label><span>{{data.NameField}}</span>
  </div>

  <button (click)="foo()">Click me!</button>
  `,
  styles: [`.dynamic-demo {
                   color: greenyellow;
                   background-color: cornflowerblue;
                 }`]
  })
 class DynamicSearchComponent {

    constructor(private hostElement: ElementRef) {
    }

    ngOnInit() {
    }

    async foo() {
      await this.bar();
      alert("I am " + this.data.Name);
    }

    async bar() {
      return 1;
    }
 }

 * Typical template only:

 <sb-search-welcome [firstName]="Name"></sb-search-welcome>
 <div class="dynamic-demo">
   <label>Name</label><span>{{Name}}</span>
   <label>Active</label><span>{{Active}}</span>
   <label>Name field</label><span>{{NameField}}</span>
 </div>
 <button (click)="foo()">Click me!</button>

 */
@Component({
  selector: 'sb-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchResultComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('content', {read: ViewContainerRef, static: false}) content: ViewContainerRef;

  @Input()
  configuration: FullTextSearchConfigurationModel = {};

  @Input()
  data: any = {};

  private componentRef: ComponentRef<any>;

  constructor(private dynamicComponentService: DynamicComponentService, private injector: Injector, private hostElement: ElementRef, private renderer: Renderer2, private utilService: UtilService) { }

  ngOnInit() {
  }

  async ngAfterViewInit() {
    this.utilService.tickThen(() => this.generateDynamicComponent());
  }

  ngOnDestroy(): void {
    this.componentRef && this.componentRef.destroy();
  }

  private async generateDynamicComponent() {
    this.configuration.template = this.configuration.template || "";
    if (this.configuration.knockout) {
      this.makeKnockoutComponent();
    } else {

      if (this.configuration.template) {
        // The parameters to customise the component
        const parameters = {};

        // The data that populates the component
        const data = this.data;

        const implementation = this.configuration.template;
        const template = null;
        const styles = null;

        const modules = [CommonModule, SearchResultModule, SharedModule];

        const componentRef =
          await this.dynamicComponentService.makeDynamicComponent({
            type: 'search',
            id: this.configuration.id,
            content: this.content,
            injector: this.injector,
            modules: modules,
            template: template,
            styles: styles,
            implementation: implementation,
            parameters: parameters,
            data: data
          });
        this.componentRef = componentRef;
      } else {

      }
    }
  }

  private registerKnockoutSearchTemplate(configuration: FullTextSearchConfigurationModel) {
    const id = "ng-ko-search-template-" + configuration.target_table;

    if (document.getElementById(id) == null) {
      const node = document.createElement("script");

      node.type = "text/html";
      node.id = id;
      node.innerHTML = configuration.template || "<h1>-- no template --</h1>";

      document.body.appendChild(node);
    }

    return id;
  }

  private makeKnockoutComponent() {
    const templateName = this.registerKnockoutSearchTemplate(this.configuration);

    const element = this.hostElement.nativeElement;
    const childElement = document.createElement('div');
    childElement.classList.add("servicely-search-result-content");
    this.renderer.appendChild(element, childElement);

    (window as any).KO.cleanNode(element);
    (window as any).KO.renderTemplate(templateName, this.data, {}, childElement, "replaceChildren");
  }
}
